export const portal = {
  // documents: {
  //   data: {
  //     files: [],
  //     language: null,
  //     type: 'document'
  //   }
  // },
  videos: [
    {
      files: [{
        tag: 'k25k_teW0iw',
        title: 'Complete Overview'
      }, {
        tag: 'nsZ70-UduRM',
        title: 'Show Map'
      }, {
        tag: 'ta9vzK7xnHc',
        title: 'Reports'
      }, {
        tag: 'ycANkUZ9aGA',
        title: 'Vendor Management'
      }],
      language: 'English',
      type: 'video'
    },
    {
      files: [{
        tag: '4OgOrzHzz7E',
        title: 'Compleet Overzicht'
      }, {
        tag: 'Jo-ngBsmIKE',
        title: 'Kaart'
      }, {
        tag: 'NszL4iJDulA',
        title: 'Rapportages'
      }, {
        tag: 'fTjtBRllTWk',
        title: 'Vendor Management'
      }, {
        tag: 'qKEZRyVbbw0',
        title: 'Onderhoudsplannen'
      }],
      language: 'Dutch',
      type: 'video'
    }
  ]
}

export const marketing = {
  videos: [
    {
      files: [
        {
          tag: 'dvu_5SZ-vA0',
          title: 'Keep Your Bike Close'
        },
        {
          tag: '5-39X4ZNBhw',
          title: 'To the beach with your Cargobike'
        },
        {
          tag: 'dL_hFipxrKg',
          title: 'Fatbike theft protection by Tracefy'
        },
        {
          tag: 'EBjm78F-eOQ',
          title: 'Tracefy bikehunters sporen gestolen doppio bike op'
        },
        {
          tag: 'WDwPiTMnNEc',
          title: 'Youtube promo: G4S, Keep Your Bike Close'
        },
        {
          tag: 'FYIuBIMJb1U',
          title: 'Youtube promo: Flitsbezorging by Tracefy'
        },
        {
          tag: 'WndJPmnZanc',
          title: 'Lock your bike with a geofence.'
        },
        {
          tag: '-Zp_chELlhk',
          title: 'Youtube promo: Real-time tracking & Geofence for e-bikes with Tracefy GPS Tracker'
        },
        {
          tag: 'VE2inYBANiA',
          title: 'Youtube promo: Recover your bike with Tracefy'
        },
        {
          tag: '8Zor1mQ5oak',
          title: 'Tracefy App Walktrough (ENG)'
        },
        {
          tag: 'hd4-ZPGbaxo',
          title: 'Tracefy App Demonstratie (NL)'
        }
      ],
      language: null,
      type: 'video'
    }
  ],
  images: {
    data: {
      files: [
        {
          title: 'Tracefy logo payoff',
          tag: 'Tracefy-logo-payoff'
        },
        {
          title: 'Dolly-marketing 1',
          tag: 'Dolly-marketing-1'
        },
        {
          title: 'Dolly-marketing 2',
          tag: 'Dolly-marketing-2'
        },
        {
          title: 'G4S-marketing 1',
          tag: 'G4S-marketing-1'
        },
        {
          title: 'G4S-marketing 2',
          tag: 'G4S-marketing-2'
        },
        {
          title: 'G4S-marketing 3',
          tag: 'G4S-marketing-3'
        },
        {
          title: 'G4S-marketing 4',
          tag: 'G4S-marketing-4'
        },
        {
          title: 'G4S-marketing 5',
          tag: 'G4S-marketing-5'
        },
        {
          title: 'G4S-marketing 6',
          tag: 'G4S-marketing-6'
        },
        {
          title: 'Facebook promo - 1200X628',
          tag: 'facebook-image-1200X628'
        }, {
          title: 'Facebook promo - 1200X630',
          tag: 'facebook-image-1200X630'
        }, {
          title: 'Facebook promo - 1200X717',
          tag: 'facebook-image-1200X717'
        }, {
          title: 'Instagram promo - 1080x1080',
          tag: 'instagram-image-1080x1080'
        }, {
          tag: 'BOR00477_8mb',
          title: 'Marketing 1'
        }, {
          tag: 'BOR00490',
          title: 'Marketing 2'
        }, {
          title: 'Marketing 3',
          tag: 'BOR00514'
        }, {
          title: 'Marketing 4',
          tag: 'BOR00520'
        }],
      language: null,
      type: 'image'
    }
  },
  documents: {
    data: {
      files: [
        {
          tag: 'Retail-Master-Tracefy-2022-NL',
          title: 'Retail Master Tracefy 2022 NL'
        },
        {
          tag: 'Retail-Master-Tracefy-2022-ENG',
          title: 'Retail Master Tracefy 2022 ENG'
        },
        {
          tag: 'Retail-Master-Tracefy-2022-FR',
          title: 'Retail Master Tracefy 2022 FR'
        },
        {
          tag: 'Folder_tracefy_DIN_Large_2022_v1_NL',
          title: 'Tracefy Brochure'
        },
        {
          tag: 'Folder_tracefy_DIN_Large_2022_v1_EN',
          title: 'Tracefy Folder'
        },
        {
          tag: 'Folder_tracefy_DIN_Large_2022_v1_FR',
          title: 'Plaquette Tracefy'
        }
      ],
      language: null,
      type: 'document'
    }
  }
}

export const installation = {
  videos: [
    {
      files: [
      {
        tag: 'SVTN-beNK-U',
        title: 'Tracefy SOLO - Activatie & Installatie (werkplaats)'
      },
      {
        tag: 'opn_0K7fKDQ',
        title: 'Tracefy SOLO - Activation & Installation (workshop)'
      },
      {
        tag: 'qgyFpZ8s63s',
        title: 'Installation Instructions PRO - Specialized + Brose'
      },
      {
        tag: '0T6J9NQ206g',
        title: 'Pionion MGu Connector (NEW)'
      },
      {
        tag: 'nDnSigUryCw',
        title: 'Bosch Smart System (HMI)'
      },
      {
        tag: 'zIbPeCVSdpM',
        title: 'Bosch Smart System (LPP/HPP)'
      },
      {
        tag: 'edlNvcfYOIo',
        title: 'Giant Sport/Pro2 Series connector'
      },
      {
        tag: 'k9-scHfozmo',
        title: 'FIT 2.0 System'
      },
      {
        tag: 'UqU5EJbfk2Y',
        title: 'Urban Arrow'
      },
      {
        tag: 'qIbBTAk0Es0',
        title: 'Fazua Ride 60'
      },
      {
        tag: 'DoNBnK_sC9Y',
        title: 'Bosch Generation 4'
      },
      {
        title: 'Bosch Generation 2/3',
        tag: 'zuMZCtZMERg'
      },
      {
        title: 'Bosch Smart System',
        tag: 'B5wHX-DObeg'
      },
      {
        title: 'Activating High Power Port (HPP) voor Bosch Smart Drive',
        tag: 'VcymTEF9Lwk'
      },
      {
        title: 'Activating Power Port (12v - PPC) voor Bosch Generation 4',
        tag: 'HpDlnFX4lbg'
      },
      {
        title: 'Bafang M420',
        tag: '2WQT7Mh0Y18'
      },
      {
        title: 'Bafang M410',
        tag: 'Y5Vsm_UNJIk'
      },
      {
        title: 'Bafang M300/M400',
        tag: '4Rx1XLOydAk'
      },
      {
        title: 'Shimano',
        tag: 't78uD1pkptw'
      },
      {
        title: 'Tracefy Universal Connector',
        tag: 'e5TT2dAwlXs'
      },
      {
        title: 'Panasonic',
        tag: 'hHPTnoRV1fE'
      },
      {
        title: 'Klever',
        tag: '5XEXkEXXSok'
      },
      {
        tag: 'nkGj4avCRFM',
        title: 'Account activation'
      }
      ],
      language: null,
      type: 'video'
    }
  ],
  documents: {
    data: {
      files: [
        {
          tag: 'Montagehandleiding-PRO',
          title: 'Montagehandleiding PRO'
        },
        {
          tag: 'Montagehandleiding-SOLO',
          title: 'Montagehandleiding SOLO'
        },
        {
          tag: 'BES3 - Compatibilty Sheet',
          title: 'Bosch BES3 Compatibility Sheet'
        },
        {
          tag: 'Urban Arrow - Anti-diefstal montage',
          title: 'Urban Arrow - Anti-diefstal montage'
        }
      ],
      language: null,
      type: 'document'
    }
  }
}

export const app = {
  videos: [
    {
      files: [
        {
          tag: '8Zor1mQ5oak',
          title: 'Tracefy App Walktrough (ENG)'
        },
        {
          tag: 'hd4-ZPGbaxo',
          title: 'Tracefy App Demonstratie (NL)'
        }],
      language: null,
      type: 'video'
    }
  ],
  documents: {
    data: {
      files: [
        {
          tag: 'Tracefy-SOLO-app-handleiding',
          title: 'Tracefy SOLO app handleiding'
        },
        {
          tag: 'Tracefy_QuickStartGuide_NL_2022_V1',
          title: 'Tracefy App Snelstart Gids 2022'
        },
        {
          tag: 'Tracefy_QuickStartGuide_EN_2022_V1',
          title: 'Tracefy App Quick Start Guide 2022'
        },
        {
          tag: 'Tracefy_QuickStartGuide_FR_2022_V1',
          title: 'Guide de démarrage rapide de l\'application Tracefy 2022'
        }
      ],
      language: null,
      type: 'document'
    }
  }
}
